function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9349 7.62187C19.8928 7.48779 19.781 7.39002 19.6464 7.36965L13.1856 6.39594L10.2964 0.324831C10.2364 0.198164 10.1121 0.118164 9.97635 0.118164C9.84064 0.118164 9.71599 0.198164 9.65635 0.324831L6.76671 6.39631L0.305993 7.37002C0.171351 7.39039 0.0599219 7.48779 0.0174219 7.62224C-0.0243638 7.75594 0.0102791 7.90335 0.107779 8.0015L4.78314 12.7274L3.67921 19.4008C3.65635 19.5396 3.71135 19.68 3.82099 19.763C3.93135 19.8467 4.07742 19.8574 4.19706 19.7911L9.97635 16.6408L15.7549 19.7911C15.8071 19.8196 15.8646 19.8337 15.9214 19.8337C15.9953 19.8337 16.0689 19.81 16.1314 19.763C16.2414 19.68 16.2964 19.5396 16.2731 19.4008L15.1696 12.7278L19.8449 8.0015C19.9421 7.90261 19.9771 7.75557 19.9349 7.62187Z",
  fill: "#FAEA0A"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.e2b5d42c.svg";
export { ForwardRef as ReactComponent };